import React from 'react';
import BootstrapModalTitle from '../bootstrap/ModalTitle.js';
function ModalTitle(props) {
  return /*#__PURE__*/React.createElement(BootstrapModalTitle, Object.assign({
    id: "modal-title"
  }, props));
}
export default ModalTitle;